import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import WordlistContext from './_contexts/WordlistContext';

type WordlistSearchInputProps = {
  searchTerm: string;
  onSearchTermChange: (searchTerm: string) => void;
};

export default function WordlistSearchInput({ searchTerm, onSearchTermChange }: WordlistSearchInputProps) {
  const { t } = useTranslation();
  const { switched, wordlist } = useContext(WordlistContext);

  if (!wordlist) return null;

  const placeholder = t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.SEARCH_BY_KEY_WORDS', {
    language: (switched ? wordlist.targetLanguage : wordlist.sourceLanguage).name,
  });

  return (
    <div className="wordlist__search-input">
      <input
        type="text"
        className="bc-formfield__textfield"
        placeholder={placeholder}
        onChange={e => onSearchTermChange(e.target.value)}
        value={searchTerm}
        autoFocus
      />
      {!searchTerm ? (
        <svg className="wordlist__search-adornment icon" role="img">
          <use href="#icon-search" />
        </svg>
      ) : (
        <button className="wordlist__search-adornment wordlist__search-clear" onClick={() => onSearchTermChange('')}>
          <svg className="icon" role="img">
            <use href="#icon-cross" />
          </svg>
        </button>
      )}
    </div>
  );
}
